import React, { useState } from 'react';
import { WhatsappLogo, X, Headset } from '@phosphor-icons/react';
import { trackEvent } from '../lib/metaPixel';

const PHONE = '541171740757';
const DEFAULT_MSG = encodeURIComponent(
  'Hola Agency Market! Necesito soporte / recargas.'
);

export const WhatsAppFloatingButton = () => {
  const [open, setOpen] = useState(false);

  const url = `https://wa.me/${PHONE}?text=${DEFAULT_MSG}`;

  const fireContact = () => {
    // 🎯 Meta Pixel: Contact event al iniciar chat por WhatsApp
    trackEvent('Contact', { channel: 'whatsapp' });
  };

  return (
    <div className="fixed bottom-20 right-4 sm:bottom-24 sm:right-6 z-[60] flex flex-col items-end gap-3">
      {open && (
        <div
          className="bg-card border border-border shadow-2xl rounded-2xl p-5 w-72 animate-slide-in-up"
          data-testid="whatsapp-popup"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center">
                <Headset size={20} weight="fill" className="text-white" />
              </div>
              <div>
                <div className="font-semibold text-sm">Soporte Agency Market</div>
                <div className="text-xs text-[#00E676]">En línea</div>
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-muted-foreground hover:text-foreground"
              aria-label="Cerrar"
            >
              <X size={16} />
            </button>
          </div>
          <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
            Hola! 👋 Únicamente para <strong className="text-foreground">soporte</strong> y{' '}
            <strong className="text-foreground">recargas</strong> de tus pedidos. Escribinos por
            WhatsApp y te respondemos.
          </p>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={fireContact}
            data-testid="whatsapp-popup-cta"
            className="flex items-center justify-center gap-2 w-full bg-gradient-to-r from-green-500 to-green-600 hover:opacity-90 text-white font-semibold py-3 rounded-xl transition-opacity"
          >
            <WhatsappLogo size={20} weight="fill" />
            Hablar por WhatsApp
          </a>
          <p className="text-[10px] text-center text-muted-foreground mt-3">
            +54 11 7174-0757 · Soporte y recargas
          </p>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="group relative w-14 h-14 rounded-full bg-gradient-to-br from-green-500 to-green-600 shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200 flex items-center justify-center"
        data-testid="whatsapp-floating-button"
        aria-label="Contactanos por WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-30" />
        <WhatsappLogo size={28} weight="fill" className="text-white relative z-10" />
      </button>
    </div>
  );
};
